import { useTranslation } from 'react-i18next'

import { Badge, Typography } from '@percent/lemonade'

export type UnlistedBadgeProps = {
  entityType: 'fundraiser' | 'opportunity'
}

const translationKeys = {
  fundraiser: 'workplace_giving.common.unlistedFundraiser',
  opportunity: 'workplace_giving.common.unlistedOpportunity'
} as const

export function UnlistedBadge({ entityType }: Readonly<UnlistedBadgeProps>) {
  const { t } = useTranslation()

  return (
    <Badge variant="interactive" testId="unlisted-badge" shape="oval">
      <Typography>{t(translationKeys[entityType])}</Typography>
    </Badge>
  )
}
